module.exports = new __parcel__URL__("soccer.5e1d6e95.jpg").toString();